import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/constants/site";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="whitespace-nowrap">{t("categories.dropdownLabel")}</span>
        <i className="ri-arrow-down-s-line flex h-4 w-4 items-center justify-center text-base leading-none" />
      </button>

      {open && (
        <div
          role="listbox"
          className="absolute left-0 z-50 mt-2 max-h-96 w-64 overflow-auto rounded-lg border border-background-200 bg-background-50 py-1 shadow-sm"
        >
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              role="option"
              className="flex items-center justify-between whitespace-nowrap px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              <span>{t(`categories.${c.key}`)}</span>
              <i className="ri-arrow-right-up-line flex h-4 w-4 items-center justify-center text-foreground-400" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}